/**
 * Floating video bubble - Vanilla JS module
 *
 * The progress bar is handled entirely by this theme's existing
 * <xo-product-video-card> web component (assets/xo-webcomponents.js) via its
 * own "timeupdate" listener on the <video> - this script only opens/closes
 * the modal and starts/stops playback with sound.
 */

(function () {
  'use strict';

  function initOne(widget) {
    if (widget.dataset.xoBound === 'true') return;
    widget.dataset.xoBound = 'true';

    // "position: fixed" only escapes to the viewport when no ancestor has an
    // active transform (this theme applies transform-based animations to
    // most blocks). Move the widget to be a direct child of <body> so it is
    // never trapped inside a transformed/animated ancestor's local stacking
    // context.
    if (widget.parentElement !== document.body) {
      document.body.appendChild(widget);
    }

    var trigger = widget.querySelector('[data-xo-video-bubble-trigger]');
    var modal = widget.querySelector('[data-xo-video-bubble-modal]');
    var closeEls = widget.querySelectorAll('[data-xo-video-bubble-close]');
    var video = widget.querySelector('.xo-video-bubble-modal__video');
    var closeOnEnd = widget.dataset.closeOnEnd === 'true';

    function openModal() {
      modal.hidden = false;
      document.addEventListener('keydown', handleKeydown);
      if (video) {
        video.muted = false;
        video.currentTime = 0;
        video.play().catch(function () {});
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.removeEventListener('keydown', handleKeydown);
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    }

    if (trigger) {
      trigger.addEventListener('click', openModal);
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    if (video && closeOnEnd) {
      video.addEventListener('ended', closeModal);
    }
  }

  function init() {
    document.querySelectorAll('[data-xo-video-bubble-widget]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
